import React, { Suspense } from 'react';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import Cookies from 'js-cookie';
import PrivateRoute from './PrivateRoute';
import SelectCompanyRoute from './SelectCompanyRoute';
import ProtectedRoute from '../components/protected/ProtectedRoute';
import MainLayout from '../layouts/MainLayout';
import LoginPage from '../components/pages/LoginPage';
import SelectCompanyPage from '../components/pages/SelectCompanyPage';
import PageNotFound from '../components/pages/PageNotFound';
import { AppRoutes } from './AppRoutes';
import PublicRoute from './PublicRoute';
import { COOKIE_KEYS } from 'config/cookieConstants';

// Lazy-loaded pages
const Dashboard = React.lazy(() => import('../components/pages/Dashboard'));
const ListAdministrator = React.lazy(() => import('../components/pages/ListAdministrator'));
const CreateAdministrator = React.lazy(() => import('../components/pages/CreateAdministrator'));
const ListCustomer = React.lazy(() => import('../components/pages/ListCustomer'));
const CreateCustomer = React.lazy(() => import('../components/pages/CreateCustomer'));
const ListSeparator = React.lazy(() => import('../components/pages/ListSeparator'));
const CreateSeparator = React.lazy(() => import('../components/pages/CreateSeparator'));
const ListLockers = React.lazy(() => import('../components/pages/ListLockers'));
const CreateLockers = React.lazy(() => import('../components/pages/CreateLockers'));
const ListOrganization = React.lazy(() => import('../components/pages/ListOrganization'));
const CreateOrganization = React.lazy(() => import('../components/pages/CreateOrganization'));
const ListAllocations = React.lazy(() => import('../components/pages/ListAllocation'));
const CreateAllocation = React.lazy(() => import('../components/pages/CreateAllocation'));
const ListNotice = React.lazy(() => import('../components/pages/ListNotice'));
const CreateNotice = React.lazy(() => import('../components/pages/CreateNotice'));
const CreateCompanyFeatures = React.lazy(() => import('../components/pages/CreateCompanyFeatures'));

const AppRouter: React.FC = () => {
  const isAuthenticated = !!Cookies.get(COOKIE_KEYS.TOKEN);

  return (
    <Router>
      <Suspense fallback={<div className='flex items-center justify-center h-screen'>Carregando...</div>}>
        <Routes>
          {/* Public */}
          {/* Rotas que só devem ser acessadas por usuários NÃO autenticados */}
          <Route element={<PublicRoute />}>
            <Route path={AppRoutes.LOGIN} element={<LoginPage />} />
          </Route>

          {/* Protege a seleção de empresa - só quem logou pode acessar */}
          <Route element={<SelectCompanyRoute />}>
            <Route path={AppRoutes.SELECT_COMPANY} element={<SelectCompanyPage />} />
          </Route>

          {/* Protege todas as demais rotas privadas */}
          <Route element={<PrivateRoute />}>
            <Route
              path={AppRoutes.DASHBOARD}
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <MainLayout setIsDarkMode={() => { }} />
                </ProtectedRoute>
              }
            >
              {/* Administrador */}
              <Route index element={<Dashboard />} />
              <Route path={AppRoutes.ADMINISTRATOR} element={<ListAdministrator />} />
              <Route path={AppRoutes.ADMINISTRATOR_CREATE} element={<CreateAdministrator />} />
              <Route path={AppRoutes.ADMINISTRATOR_VIEW} element={<CreateAdministrator />} />

              {/* Cliente */}
              <Route path={AppRoutes.CUSTOMER} element={<ListCustomer />} />
              <Route path={AppRoutes.CUSTOMER_CREATE} element={<CreateCustomer />} />
              <Route path={AppRoutes.CUSTOMER_VIEW} element={<CreateCustomer />} />

              {/* Separador */}
              <Route path={AppRoutes.SEPARATOR} element={<ListSeparator />} />
              <Route path={AppRoutes.SEPARATOR_CREATE} element={<CreateSeparator />} />
              <Route path={AppRoutes.SEPARATOR_VIEW} element={<CreateSeparator />} />

              {/* Lockers */}
              <Route path={AppRoutes.LOCKERS} element={<ListLockers />} />
              <Route path={AppRoutes.LOCKERS_CREATE} element={<CreateLockers />} />
              <Route path={AppRoutes.LOCKERS_VIEW} element={<CreateLockers />} />

              {/* Organização */}
              <Route path={AppRoutes.ORGANIZATION} element={<ListOrganization />} />
              <Route path={AppRoutes.ORGANIZATION_CREATE} element={<CreateOrganization />} />
              <Route path={AppRoutes.ORGANIZATION_VIEW} element={<CreateOrganization />} />

              {/* Alocação */}
              <Route path={AppRoutes.ALLOCATION} element={<ListAllocations />} />
              <Route path={AppRoutes.ALLOCATION_CREATE} element={<CreateAllocation />} />
              <Route path={AppRoutes.ALLOCATION_VIEW} element={<CreateAllocation />} />

              {/* Alocação */}
              <Route path={AppRoutes.NOTICE} element={<ListNotice />} />
              <Route path={AppRoutes.NOTICE_CREATE} element={<CreateNotice />} />
              <Route path={AppRoutes.NOTICE_VIEW} element={<CreateNotice />} />

              {/* Config */}
              <Route path={AppRoutes.CONFIG} element={<CreateCompanyFeatures />} />

              {/* 404 */}
              <Route path={AppRoutes.NOT_FOUND} element={<PageNotFound />} />
            </Route>
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
};

export default AppRouter;
